import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";

export default function CoachSessionsIndex() {
  const [learners, setLearners] = useState([]);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/coach/learners").then(({ data }) => {
      setLearners(data);
      if (data.length === 1) navigate(`/coach/apprenants/${data[0].id}`, { replace: true });
    });
  }, [navigate]);

  const filtered = learners.filter(l => !q || `${l.first_name} ${l.last_name}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <h1 className="font-serif-accent text-3xl sm:text-4xl">Séances</h1>
      <p className="text-[#5C6561] mt-1 mb-6">Choisissez un apprenant pour gérer ses 40 séances.</p>
      <Input placeholder="Rechercher un apprenant…" value={q} onChange={(e) => setQ(e.target.value)} className="bg-white max-w-md mb-4" />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {filtered.map(l => (
          <Link key={l.id} to={`/coach/apprenants/${l.id}`} className="dec-card p-4 hover:border-[#D95D39]">
            <div className="font-semibold">{l.first_name} {l.last_name}</div>
            <div className="text-xs text-[#5C6561]">{l.email} • {l.level}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
